<script setup>
import { computed } from 'vue';

// Ranking por identidade (qual agente respondeu mais), então a identidade mora
// no rótulo e não na cor: uma barra por linha, todas do mesmo tom, valor escrito
// ao lado. HTML puro — um canvas aqui só acrescentaria peso.
const props = defineProps({
  entries: { type: Array, default: () => [] }, // [{ key, label, value }]
  limit: { type: Number, default: 5 },
  barClass: { type: String, default: 'bg-n-brand' },
  emptyLabel: { type: String, default: '' },
});

const nf = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });

const top = computed(() => props.entries.slice(0, props.limit));

// A escala é o maior do ranking, não o total: comparar entre si é a leitura útil.
const max = computed(() =>
  top.value.reduce((acc, entry) => Math.max(acc, entry.value), 0)
);

const widthOf = entry =>
  max.value > 0 ? `${Math.max((entry.value / max.value) * 100, 2)}%` : '0%';
</script>

<template>
  <div v-if="top.length" class="flex flex-col gap-3">
    <div v-for="entry in top" :key="entry.key" class="flex flex-col gap-1">
      <div class="flex gap-3 justify-between items-baseline min-w-0">
        <span class="text-sm truncate text-n-slate-12">{{ entry.label }}</span>
        <span class="text-sm font-medium tabular-nums text-n-slate-11">
          {{ nf.format(entry.value) }}
        </span>
      </div>
      <div class="overflow-hidden w-full h-2 rounded-full bg-n-alpha-1">
        <div
          class="h-full rounded-full"
          :class="barClass"
          :style="{ width: widthOf(entry) }"
        />
      </div>
    </div>
  </div>
  <div v-else class="py-8 text-sm text-center text-n-slate-10">
    {{ emptyLabel }}
  </div>
</template>
